import React from 'react'
import './work.scss'
import { data } from '../../utils/work_data'

function Work() {
   return (
      <div className="work">
         <h3>Projects</h3>
         <div className="work__wrapper">
            {data.map((dat, index) => (
               <div className={`work__wrapper--item ${dat.className}`} key={index}>
                  <div className="work__wrapper--item-content">
                     <a
                        href={dat.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="btn btn__work">
                        <span>{dat.title}</span>
                     </a>
                  </div>
               </div>
            ))}
         </div>
      </div>
   )
}

export default Work
